// listen to a specific script tag change (when loaded via GTM)
export function trackingHotjar() {
    //Create the observer
    const myObserver = new MutationObserver((mutationList) => {
        mutationList.forEach((mutation) => {
            switch (mutation.type) {
                case "childList":
                    if (mutation.addedNodes && mutation.addedNodes.length) {
                        const nodes = mutation.addedNodes;
                        for (let i = 0; i < nodes.length; i++) {
                            if (nodes[i].nodeName.toLowerCase() === "script") {
                                const nodeHTML = nodes[i] as HTMLElement;
                                if (!nodeHTML) {
                                    return;
                                }
                                const attr = nodeHTML.getAttribute("src");
                                if (attr && attr.indexOf("hotjar.com") > -1) {
                                    // get the name of the event from PHP
                                    const eventName =
                                        document.querySelector<HTMLElement>(
                                            "[data-tracking-event]",
                                        );
                                    if (eventName) {
                                        // @ts-ignore
                                        hj(
                                            "event",
                                            eventName.dataset.trackingEvent,
                                        );
                                    }

                                    // only hotjar for feedback button on click
                                    const feebackButton =
                                        document.querySelector<HTMLElement>(
                                            ".feedback-button",
                                        );
                                    if (feebackButton) {
                                        feebackButton.addEventListener(
                                            "click",
                                            (e) => {
                                                e.preventDefault();
                                                // @ts-ignore
                                                hj(
                                                    "event",
                                                    "hotjarUserFeedback",
                                                );
                                            },
                                        );
                                    }
                                }
                            }
                        }
                    }
                    break;
            }
        });
    });

    //Observe the body and head as that's where scripts might be placed - body not necessary yet
    /*const body = document.querySelector('body');*/
    const head = document.querySelector("head");

    //options to look for per-element
    //childList and subtree must be set to true
    const options = {
        childList: true,
        subtree: true,
    };
    /*myObserver.observe(body, options);*/
    // @ts-ignore
    myObserver.observe(head, options);
}
